module.exports = __webpack_public_path__ + "static/media/Reporting13.addef4d0.png";